var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 3C16.0074 3 15 4.00736 15 5.25C15 6.49264 16.0074 7.5 17.25 7.5C18.4926 7.5 19.5 6.49264 19.5 5.25C19.5 4.00736 18.4926 3 17.25 3ZM13.5 5.25C13.5 3.17893 15.1789 1.5 17.25 1.5C19.3211 1.5 21 3.17893 21 5.25C21 7.32107 19.3211 9 17.25 9C15.1789 9 13.5 7.32107 13.5 5.25Z",
    fill: "#0D0F13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 16.5C16.0074 16.5 15 17.5074 15 18.75C15 19.9926 16.0074 21 17.25 21C18.4926 21 19.5 19.9926 19.5 18.75C19.5 17.5074 18.4926 16.5 17.25 16.5ZM13.5 18.75C13.5 16.6789 15.1789 15 17.25 15C19.3211 15 21 16.6789 21 18.75C21 20.8211 19.3211 22.5 17.25 22.5C15.1789 22.5 13.5 20.8211 13.5 18.75Z",
    fill: "#0D0F13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 9.75C4.00736 9.75 3 10.7574 3 12C3 13.2426 4.00736 14.25 5.25 14.25C6.49264 14.25 7.5 13.2426 7.5 12C7.5 10.7574 6.49264 9.75 5.25 9.75ZM1.5 12C1.5 9.92893 3.17893 8.25 5.25 8.25C7.32107 8.25 9 9.92893 9 12C9 14.0711 7.32107 15.75 5.25 15.75C3.17893 15.75 1.5 14.0711 1.5 12Z",
    fill: "#0D0F13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9645 7.27577L8.24979 11.1496L7.50021 9.85037L14.2149 5.97649L14.9645 7.27577Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24979 12.8504L14.9646 16.7243L14.2151 18.0236L7.50021 14.1496L8.24979 12.8504Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share_icon.aa896c87d2e90a1a34b6cd49ce30df30.svg";